
const DEVICE_ID_KEY = 'device_id'

export async function generateDeviceFingerprint(): Promise<string> {
  try {
    const fpPromise = await import('@fingerprintjs/fingerprintjs')
    const fp = await fpPromise.load()
    const result = await fp.get()
    const deviceId = result.visitorId

    localStorage.setItem(DEVICE_ID_KEY, deviceId)
    sessionStorage.setItem(DEVICE_ID_KEY, deviceId)
    
    return deviceId
  } catch (error) {
    console.error('生成设备指纹时出错:', error)
    const fallbackId = `fallback_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`
    localStorage.setItem(DEVICE_ID_KEY, fallbackId)
    sessionStorage.setItem(DEVICE_ID_KEY, fallbackId)
    return fallbackId
  }
}



export async function getDeviceFingerprint(): Promise<string> {
  const sessionId = sessionStorage.getItem(DEVICE_ID_KEY)
  if (sessionId) {
    return sessionId
  }
  const localId = localStorage.getItem(DEVICE_ID_KEY)
  if (localId) {
    sessionStorage.setItem(DEVICE_ID_KEY, localId)
    return localId
  }
  return generateDeviceFingerprint()
}